export const EXTERNAL_SYSTEMS_SLICE = 'EXTERNAL_SYSTEMS_SLICE';
